<template>
  <el-dialog :visible.sync="bwmvisible"
             :title="!dataForm.id ? $t('user.transfer') : $t('user.transfer')"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="700px">
    <el-form :model="modifyForm"
             :rules="dataRule"
             ref="modifyForm"
             style="margin-top:10px;padding-bottom:50px"
             label-position="top">
      <el-row>
        <el-col :span="5">
          <el-form-item label=""></el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label=""><span style="font-size:16px;font-weight:bold">转岗前</span></el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label=""></el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label=""><span style="font-size:16px;font-weight:bold">转岗后</span></el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top:20px">
        <el-col :span="9"
                :offset="3">
          <!-- 转岗前职位 -->
          <el-form-item :label="$t('user.posit')"
                        prop="">
            <el-tooltip class="item"
                        effect="dark"
                        placement="top"
                        :disabled="false">
              <div slot="content">{{beforJobCodeNum}}<br />{{beforJobCodeContent}}</div>
              <el-select v-model="dataForm.jobCode"
                         :disabled="true">
                <el-option v-for="item in positionlist"
                           :key="item.positionId"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="9"
                :offset="2">
          <!-- 转岗后职位 -->
          <el-form-item :label="$t('user.posit')"
                        prop="jobCode">
            <el-tooltip class="item"
                        effect="dark"
                        placement="right"
                        :disabled="!modifyForm.jobCode || modifyForm.jobCode === ''">
              <div slot="content"
                   v-html="jobCodeContent"></div>
              <el-select v-model="modifyForm.jobCode"
                         :placeholder="$t('user.positionPlaceholder')"
                         :disabled="false"
                         remote
                         filterable
                         clearable
                         @change="jobCodeClean(modifyForm.jobCode)"
                         :remote-method="queryMainPosition">
                <el-option v-for="item in transferPositionlist"
                           :key="item.positionId"
                           :label="item.positionName"
                           :value="item.positionCode">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="width:100%;text-align:center">
      <el-button type="primary"
                 style="width:90px;height:36px"
                 @click="dataFormSubmitHandle()">{{$t('confirm')}}</el-button>
      <el-button style="width:90px;height:36px;margin-left:20px"
                 @click="bwmvisible = false">{{$t('cancel')}}</el-button>
    </div>
    <div class="box">
      <div class="line"></div>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import AesUtil from "@/utils/aes_utils";
export default {
  data() {
    return {
      bwmvisible: false,
      deptList: [],
      deptListVisible: false,
      // 转岗前主要职位
      positionlist: '',
      id: '',
      dataForm: {
        userId: ''
      },
      // 转岗后列表
      modifyForm: {
        jobCode: ''
      },
      // 提交转岗列表
      trandferForm: {},
      jobCodeabled: false,
      // 转岗后职位信息描述
      jobCodeContent: this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent'),
      // 转岗后职位代码
      jobCodeNum: this.$t('activiti.jobCodeNum'),
      // 转岗前职位代码
      beforJobCodeNum: this.$t('activiti.jobCodeNum'),
      // 转岗前职位信息描述
      beforJobCodeContent: this.$t('activiti.jobCodeContent'),
      dialogshow: true,
      // 判断是否可以转岗
      trandferCode: '',
      transferPositionlist: []
    }
  },
  // 校验
  computed: {
    dataRule() {
      return {
        jobCode: [
          { required: true, message: this.$t('user.userJobCode'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    init() {
      this.bwmvisible = true
      const base64url = require('base64-url')
      let aes = new AesUtil()
      let userId = base64url.encode(aes.encrypt(this.id + ''))
      this.$request.get(`/sys/commuser/infomt/${userId}`).then((res, total, code, data) => {
        this.dataForm = JSON.parse(JSON.stringify(res))
        this.modifyForm = JSON.parse(JSON.stringify(res))
        this.dataForm.orgId = this.dataForm.orgId + ''
        this.modifyForm.orgId = this.modifyForm.orgId + ''
        this.$request.get(`/sys/commuser/selectPositionByCode`,
          {
            positionCode: this.dataForm.jobCode
          }
        ).then((res, total, code, data) => {
          this.positionlist = JSON.parse(JSON.stringify(res))
          this.transferPositionlist = JSON.parse(JSON.stringify(res))
          if (this.dataForm.jobCode === '' || this.dataForm.jobCode === undefined || this.dataForm.jobCode === null) {
            this.jobCodeNum = this.$t('activiti.jobCodeNum')
            this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
            this.beforJobCodeNum = this.$t('activiti.jobCodeNum')
            this.beforJobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
          } else {
            this.jobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
            if (res[0].positionDesc) {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + res[0].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
            }
            this.beforJobCodeNum = this.$t('activiti.jobCodeNum') + res[0].positionCode
            if (res[0].positionDesc) {
              this.beforJobCodeContent = this.$t('activiti.jobCodeContent') + res[0].positionDesc
            } else {
              this.beforJobCodeContent = this.$t('activiti.jobCodeContent')
            }
          }
        }).catch(() => { })
      }).catch(() => { })
    },
    // 获取主要职位list
    queryMainPosition(queryString) {
      this.$request.post('/sys/commuser/commPositionByParam',
        {
          orgType: this.dataForm.orgType,
          orgId: this.dataForm.orgId,
          positionName: queryString
        }).then((res, total, code, data) => {
          this.transferPositionlist = res
        }).catch(() => { })
      if (this.modifyForm.jobCode === '' || this.modifyForm.jobCode === undefined || this.modifyForm.jobCode === null) {
        this.jobCodeContentClean()
      }
    },
    // 判断转岗职位有无变化
    jobCodeChange() {
      this.dialogshow = true
      if (this.modifyForm.jobCode !== '' && this.modifyForm.jobCode !== undefined && this.modifyForm.jobCode !== null) {
        if (this.modifyForm.jobCode === this.dataForm.jobCode) {
          this.$alert(this.$t('user.verificationparttimeJobCodeSame'), this.$t('prompt.title')).then(() => {
          }).catch(() => { })
          this.dialogshow = false
        } else {
          this.dialogshow = true
        }
      }
    },
    // 清空主要职位职位描述
    jobCodeContentClean() {
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
    },
    jobCodeClean(jobCode) {
      this.jobCodeContent = this.$t('activiti.jobCodeNum') + '<br/>' + this.$t('activiti.jobCodeContent')
      this.jobCodeNum = this.$t('activiti.jobCodeNum')
      if (jobCode && jobCode !== '') {
        for (let i = 0; i < this.transferPositionlist.length; i++) {
          if (jobCode === this.transferPositionlist[i].positionCode) {
            this.jobCodeNum = this.$t('activiti.jobCodeNum') + this.transferPositionlist[i].positionCode
            if (this.transferPositionlist[i].positionDesc) {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent') + this.transferPositionlist[i].positionDesc.replace(/\n/g, "<br/>")
            } else {
              this.jobCodeContent = this.jobCodeNum + '<br/>' + this.$t('activiti.jobCodeContent')
            }
          }
        }
      } else {
        this.queryMainPosition('')
      }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['modifyForm'].validate((valid) => {
        if (!valid) {
          return false
        } else {
          this.jobCodeChange()
          if (this.dialogshow === true) {
            this.trandferForm = {
              // 用户id
              userId: this.modifyForm.userId,
              // 版本号
              version: this.dataForm.version,
              // 原主职code
              positionOriginalCode: this.dataForm.jobCode,
              // 目标主职code
              positionDestinationCode: this.modifyForm.jobCode,
              // 原主职网点id
              positionOriginalNetworkId: this.dataForm.orgId,
              // 目标主职网点id
              positionDestinationNetworkId: this.modifyForm.orgId
            }
            this.$request.post(`/sys/position/transfer/save`,
              this.trandferForm
            ).then((res, total, code, data) => {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.bwmvisible = false
                  this.$emit('refreshDataList')
                }
              })
            }).catch(() => { })
          } else {
            this.bwmvisible = true
          }
        }
      })
    }, 3000, { 'leading': true, 'trailing': false })
  },
  activated() {
    this.modifyForm = {}
    this.dataForm = {}
  }
}
</script>
<style lang="scss" scoped>
.box {
  position: relative;
}
.line {
  height: 120px;
  width: 0px;
  border: 1px dashed #5e5ee4;
  box-sizing: border-box;
  position: absolute;
  left: 50%;
  top: -210px;
  z-index: 100;
}
</style>
